<template>
    <div id="app">
        <!-- 这里是需要keepalive的 -->
        <!-- <keep-alive>
            <router-view></router-view>
        </keep-alive> -->
        <!-- 这里不会被keepalive -->
        <!-- <router-view v-if="!$route.meta.keepAlive"></router-view> -->
        <router-view v-if="isRouterAlive"></router-view>
        <backto-top />
    </div>
</template>

<script>
export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload
        }
    },
    data() {
        return {
            isRouterAlive: true
        }
    },

    methods: {
        reload() {
            this.isRouterAlive = false
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        }
    }
}
</script>

<style lang="scss">
#nprogress {
    .bar {
        background: $menuFocus !important; //自定义颜色
        height: 3px !important;
    }
    .spinner {
        top: 7px !important;
        right: 5px !important;
        .spinner-icon {
            border-top-color: $menuFocus !important;
            border-left-color: $menuFocus !important;
        }
    }
}
</style>
